import { mediasFields } from './composer'

export const getEventBySlug = () => {
  return `query getEventBySlug($slug: String!) {
  eventBySlug(slug: $slug) {
    title
    start
    end
    type
    slug
    programnote {
      title
      program {
        getUrl
      }
    }
    location {
      name
      hall
      city {
        name
        country {
          name
        }
      }
    }
    medias {
      ${mediasFields}
    }
  }
  }`
}
